import template from '../../../../views/statistic/partials/ab-test-campaigns.html';

export default class abTestCampaigns {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                abTest: '=',
                statistics: '=',
                colorMap: '='
            },
            template: template,
            controller: [ '$scope', '$element', '$attrs', '$rootScope', '$filter', 'Campaign', 'SweetAlert', 'Events', (scope, element, attr, $rootScope, $filter, Campaign, SweetAlert, Events) => {

                scope.getColor = (campaign, index) => {
                    var colorPos = scope.isWinner(campaign) ? 'main' : index;
                    var color = scope.colorMap[colorPos];

                    // We have to add opacity in this way, because simple opacity property
                    // in css ruins z-index structured document and we model window doesn't work correct
                    if (! scope.isActive(campaign)) {
                        color = color.replace(/,1\)/i, ',0.4)');
                    }

                    return { background: color };
                };

                scope.isWinner = (campaign) => {
                    return campaign.id === scope.abTest.winner_campaign_id;
                };

                scope.toggleCampaignActive = (campaign) => {
                    campaign.active = !campaign.active;

                    $rootScope.$emit("statistics:abTest:recount");
                    $rootScope.$emit('statistics:abTest:redraw');
                };

                scope.isActive = (campaign) => {
                    return campaign.active;
                };

                scope.copyCampaign = (event, campaignId, messageTypeId) => {
                    event.stopPropagation();
                    var excludeAbTestId = true;

                    Campaign.copy(campaignId, excludeAbTestId).then(function () {
                        Events.flashEvent('notification', $filter('translate')('CAMPAIGN:FLASH:COPY'));
                    }, (error) => {
                        SweetAlert.swal({
                            title: $filter('translate')('GLOBAL:OOPS'),
                            text: $filter('translate')('CAMPAIGN:FLASH:COPY_ERROR_TITLE'),
                            type: 'error'
                        });
                    });
                };


                scope.enablePreview = function() {
                    return ! scope.isAbTest;
                };
            }]
        }
    }
}
